export const EXO_SKELETON_RUNTIME_SCOPE = 'ExoSkeletonRuntime';

declare global {
  interface Window {
    [EXO_SKELETON_RUNTIME_SCOPE]?: {
      available?: boolean;
    };
  }
}

export function getExoSkeletonRuntime(host: Window | WindowProxy = window) {
  if (!host[EXO_SKELETON_RUNTIME_SCOPE]) {
    host[EXO_SKELETON_RUNTIME_SCOPE] = {};
  }

  return host[EXO_SKELETON_RUNTIME_SCOPE];
}

/**
 * Should be used only by the ExoSkeleton.
 */
export function setIsInExoSkeleton() {
  const runtime = getExoSkeletonRuntime();

  runtime.available = true;
}

export function createUniqueRequestId(prefix = '') {
  return `${prefix}${Math.random().toString(16).slice(2)}`;
}

export function notInExoSkeletonError({ source }: { source: string }) {
  return new Error(
    `Cannot execute "${source}" outside of the ExoSkeleton, please use "setIsInExoSkeleton" to set the runtime environment`,
  );
}
